var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('hr')])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_vm._t("SideNavigation")],2),_c('div',{staticClass:"col-md-8"},[_vm._t("MainContent")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }